import { z } from 'zod';

import { DatasetVersionStatusEnum } from './dataset-schema-versions';
import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

// Define the possible values for dataset file types
export const DatasetFileTypeEnum = z.enum(['csv', 'xlsx']);

export type DatasetFileType = z.infer<typeof DatasetFileTypeEnum>;

export const DatasetDataVersionSchema = z.object({
  datasetDataVersionId: PrimaryKeySchema,
  datasetId: PrimaryKeySchema,
  versionNo: z.number().int().positive(),
  sourceFileUri: z.string().max(1024),
  fileType: DatasetFileTypeEnum,
  status: DatasetVersionStatusEnum,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DatasetDataVersion = z.infer<typeof DatasetDataVersionSchema>;

export const DatasetDataVersionsSchema = z.array(DatasetDataVersionSchema);

export type DatasetDataVersions = z.infer<typeof DatasetDataVersionsSchema>;

export const DatasetDataVersionsQuerySchema = z
  .object({
    datasetDataVersionIds: commaDelimitedList(
      PrimaryKeySchema.array(),
    ).optional(),
    datasetIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    status: DatasetVersionStatusEnum.optional(),
    versionNo: z.coerce.number().int().positive().optional(),
    fileType: DatasetFileTypeEnum.optional(),
  })
  .merge(
    createOffsetPaginationRequestQuerySchema(
      z.enum(['createdAt', 'updatedAt', 'versionNo']),
    ),
  );

export type DatasetDataVersionsQuery = z.infer<
  typeof DatasetDataVersionsQuerySchema
>;

export const CreateDatasetDataVersionRequestSchema = z.object({
  datasetId: PrimaryKeySchema,
  sourceFileUri: z.string().max(1024),
  fileType: DatasetFileTypeEnum,
  status: DatasetVersionStatusEnum.optional().default('draft'),
});

export type CreateDatasetDataVersionRequest = z.infer<
  typeof CreateDatasetDataVersionRequestSchema
>;

export const UpdateDatasetDataVersionRequestSchema = z.object({
  status: DatasetVersionStatusEnum.optional(),
});

export type UpdateDatasetDataVersionRequest = z.infer<
  typeof UpdateDatasetDataVersionRequestSchema
>;
